//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertRequestToServer } from './Request.js'
import { axiosPost } from '../../axios/axios.js'
import { requestActions } from './RequestActions.js'
import { requestActionsCancelAssignment } from './RequestActionsCancelAssignment.js'
import { getServiceObjectCheckResult } from './RequestServiceObjectsCheck.js'
import DispatcherTasksTabRedirectToWorkArea from '../../pages/main/sections/Dispatcher/DispatcherTab/DispatcherTasksTabRedirectToWorkArea.vue'
import RequestMgtCloseRequestButton from './RequestMgtCloseRequestButton.vue'
import RequestMgtCancelRequestButton from './RequestMgtCancelRequestButton.vue'
import RequestMgtResumeRequestButton from './RequestMgtResumeRequestButton.vue'
import RequestActualizationDialog from './RequestActualizationDialog.vue'
import RequestActualizationConfirm from './RequestActualizationConfirm.vue'

export default {
  components: {
    DispatcherTasksTabRedirectToWorkArea,
    RequestMgtCloseRequestButton,
    RequestMgtCancelRequestButton,
    RequestMgtResumeRequestButton
  },
  mixins: [requestActions, requestActionsCancelAssignment],
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default: ''
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    isInitialize: {
      type: Boolean,
      default: false
    },
    onMap: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      redirectToWorkAreaOpened: false
    }
  },
  computed: {
    hasEditAccess: function () {
      return this.requestRoles.hasEditAccess // const bpStateId = this.taskStatus
    },
    displayRedirectToWorkAreaButton: function () {
      return this.request.isFieldIncluded('redirectedWorkArea') && //
             this.requestRoles.roleDispatcherOrHigher && !this.requestRoles.roleExternalDispatcher && !this.isInitialize && //
             (this.taskStatus == 'BS1' || this.taskStatus == 'BS2' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13')
    },
    isCreated: function () {
      return this.taskStatus !== 'BS0' && this.taskStatus !== null
    },
    displayCreateTaskButton: function () {
      return !this.isCreated && (this.requestRoles.roleDispatcherOrHigher || this.requestRoles.roleExternalDispatcher) && this.request.proposedExecutorObject == null
    },
    displayCreateTaskAndSetExecutorButton: function () {
      return !this.isCreated && this.requestRoles.roleDispatcherOrHigher && this.request.proposedExecutorObject != null
    },
    displaySaveChangesButton: function () {
      return this.isCreated && !this.request.hasProposedExecutor && this.hasEditAccess
    },
    displaySaveChangesAndSetExecutorButton: function () {
      if (this.isCreated && this.request.hasProposedExecutor && !this.request.synchronizeSourceRequest) {
        return this.requestRoles.executorChangeAvailable || this.requestRoles.reinforcementExecutorChangeAvailable
      }
      return false
    },
    displaySelectExecutorButton: function () {
      return !this.onMap &&
        this.request.proposedExecutorObject == null && this.requestRoles.executorChangeAvailable &&
        (this.taskStatus == 'BS2' && !this.request.synchronizeSourceRequest || this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || this.taskStatus == 'BS8' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13')
    },
    selectExecutorButtonText: function () {
      if (this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || (this.taskStatus == 'BS8' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13') && (!!this.request.assignedBrigade || !!this.request.assignedEmployee)) {
        return 'Изменить исполнителя'
      }
      return 'Выбрать исполнителя'
    },
    BS2_displayAnalyzeRequestButton: function () {
      return this.onMap &&
              this.requestRoles.roleDispatcherOrHigher &&
             (this.taskStatus == 'BS19' || this.taskStatus == 'BS21' || this.taskStatus == 'BS3' || this.taskStatus == 'BS4') &&
             !this.request.synchronizeSourceRequest
    },
    displayCloseTaskButton: function () {
      return !this.isCreated
    },
    displayCreateRequestRoadsCommand: function () {
      return this.request.isRoadsIntegrationAvailable && !!(this.request.requestId || this.request.id)
    },
    canCreateRoadsRequestCommand: function () {
      return this.$d_hasRole('roadsRequestCommandCreator')
    },
    createRequestRoadsCommandDisabled: function () {
      if (this.request.roadsRequestCommandId) {
        return false
      }
      if (!this.canCreateRoadsRequestCommand) {
        return true
      }
      return !!(this.request.unableToCreateRequestInRoadsReasons && this.request.unableToCreateRequestInRoadsReasons.length > 0)
    },
    createRequestRoadsCommandDisabledReason: function () {
      if (this.request.roadsRequestCommandId) {
        return ''
      }
      if (!this.canCreateRoadsRequestCommand) {
        return 'У вас недостаточно прав'
      }
      if (this.request.unableToCreateRequestInRoadsReasons && this.request.unableToCreateRequestInRoadsReasons.length > 0) {
        return this.request.unableToCreateRequestInRoadsReasons.join(',\n')
      }
      return ''
    },
    /**
     * Задача ПТК АПТС
     */
    displayCloseRequestMgt: function () {
      const closureInfo = this.request.supTaskData && this.request.supTaskData.closureInfo || null
      return !!(this.request.id && closureInfo && !closureInfo.closed && this.$d_hasRole('admin', 'dispatcher'))
    },
    displayCancelRequestMgt: function () {
      const cancelInfo = this.request.supTaskData && this.request.supTaskData.cancelInfo || null
      return !!(this.request.id && cancelInfo && !cancelInfo.cancelled && this.$d_hasRole('admin', 'dispatcher'))
    },
    displayResumeRequestMgt: function () {
      return false
      // const resumeInfo = this.request.supTaskData && this.request.supTaskData.resumeInfo || null
      // return !!(this.request.id && resumeInfo && (resumeInfo.cancelled || resumeInfo.closed) && this.$d_hasRole('admin', 'dispatcher'))
    },
    displayActualizeRequestDataButton: function () {
      if (!this.$d_hasRole('admin', 'dispatcher')) {
        return false
      }
      const data = this.request.supRequestActualization
      if (!data || typeof data !== 'object') {
        return false
      }
      const hasComment = data.comment != null
      const hasCoords = data.lon != null || data.lat != null
      const hasAddress = data.address != null
      const hasObjects = Array.isArray(data.serviceObjects) && data.serviceObjects.length > 0
      return hasComment || hasCoords || hasAddress || hasObjects
    }
  },
  methods: {
    createRequestRoads: function () {
      if (this.request.roadsRequestCommandId) {
        this.$router.push({
          path: '/requestRoadsCommand/' + this.request.roadsRequestCommandId
        })
      } else {
        this.$router.push({
          path: '/requestRoadsCommand/createFromRequest',
          query: { requestId: this.request.requestId || this.request.id }
        })
      }
    },

    closeTask: function () {
      this.$emit('close-task')
    },
    updateTask: function () {
      this.$emit('task-updated')
    },
    openRequestActualization: function () {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        headerLabel: 'Актуализировать данные заявки',
        contentWidth: 1000,
        contentComponent: RequestActualizationDialog,
        contentProps: {
          request: this.request,
          requestRoles: this.requestRoles,
          taskStatus: this.taskStatus
        },
        componentHandlers: {
          continue: (payload) => {
            this.openRequestActualizationConfirm(payload, dialog)
          }
        }
      })
    },
    openRequestActualizationConfirm: function (payload, formDialog) {
      const confirmDialog = this.$d.dialog(this).show({
        persistent: true,
        headerLabel: 'Подтверждение актуализации',
        contentWidth: 600,
        contentComponent: RequestActualizationConfirm,
        contentProps: {
          fields: payload.fields
        },
        componentHandlers: {
          actualize: () => {
            this.actualizeRequestData(payload.properties, formDialog, confirmDialog)
          }
        }
      })
    },
    actualizeRequestData: function (properties, formDialog, confirmDialog) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const bodyFormData = new FormData()
      bodyFormData.set('requestId', this.request.requestId)
      bodyFormData.set('properties', JSON.stringify(properties))

      axiosPost({
        url: '/service/delta/request/edit',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Данные заявки актуализированы',
            progress: true,
            timeout: 3000
          })
          confirmDialog.hide()
          formDialog.hide()
          this.$emit('task-updated')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    BS2_AnalyzeRequest: function () {
      if (this.taskStatus === 'BS3' || this.taskStatus === 'BS4') {
        this.onCancelAssignment(() => {
          this.$emit('task-updated')
        })
      } else {
        this.changePBState('BS2', null, 'Ошибка взятия заявки в анализ')
      }
    },
    createTask: async function (acceptTaskForExecution) {
      if (!(await this.isTaskValid())) {
        return
      }

      const tempRequest = convertRequestToServer(this.request, this.isInitialize)
      const tempRequestStr = JSON.stringify(tempRequest)
      const bodyFormData = new FormData()
      bodyFormData.set('properties', tempRequestStr)

      let url = '/service/delta/request/'

      if (this.request.requestsToAudit || this.request.objectsToAudit) {
        // Операция массового создание заявок на аудит и аудит объекта
        url += 'createAudit'
        if (this.request.requestsToAudit) {
          bodyFormData.set('requestsToAudit', this.request.requestsToAudit)
          // checkResult = await getAuditRequestsServiceObjectsCheckResult.call(this, this.request.requestsToAudit) // after audit -> before
        } else if (this.request.objectsToAudit) {
          bodyFormData.set('objectsToAudit', this.request.objectsToAudit)
          // checkResult = await getServiceObjectsCheckResult.call(this, this.request.objectsToAudit) // after audit -> before
        }
        bodyFormData.set('isAudit', this.request.isAudit)
      } else {
        // Остальные случаи
        url += 'create'

        if (this.request.serviceObjectId && this.request.serviceObjectId !== this.request._checkedServiceObjectId) {
          const checkResult = await getServiceObjectCheckResult.call(this, this.request.serviceObjectId, false /* проверяется ранее */) // after creation (or before if _checkedServiceObjectId)
          if (!checkResult.continueAction) {
            return
          }
        }
      }

      this.$q.loading.show({ spinnerColor: 'blue-11' })

      axiosPost({
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: async function (response) {
          if (this.request.requestsToAudit) {
            if (response.data.successCount === 0) {
              this.$q.notify({
                type: 'negative',
                message: 'Операция не выполнена',
                progress: true,
                timeout: 8000
              })
            } else if (response.data.successCount < response.data.totalCount) {
              this.$q.notify({
                type: 'warning',
                message: 'Операция выполнена частично (создано заявок: ' + response.data.successCount + ' из ' + response.data.totalCount + ')',
                progress: true,
                timeout: 8000
              })
            } else {
              this.$q.notify({
                type: 'positive',
                message: 'Операция выполнена успешно (создано заявок: ' + response.data.successCount + ')',
                progress: true,
                timeout: 3000
              })
            }

            if (response.data.result && response.data.result.length) {
              this.$q.notify({
                type: 'positive',
                message: 'Созданы заявки №: ' + response.data.result.map((result) => result.requestNumber).join(', '),
                progress: true,
                timeout: 3000
              })
            }

            if (response.data.Errors && response.data.Errors.length) {
              this.$q.notify({
                type: 'negative',
                message: response.data.Errors.join(',\n'),
                progress: true,
                timeout: 8000
              })
            }

            this.$emit('task-created')
            return
          }

          const creationResult = {
            id: response.data.result.id,
            bpContextId: response.data.result.bpContextId
          }

          this.request.requestId = creationResult.id
          this.request.requestNumber = creationResult.requestNumber
          this.request.bpStateId = 'BS1'
          this.request.bpContextId = creationResult.bpContextId

          this.$q.notify({
            type: 'positive',
            message: 'Заявка создана',
            progress: true,
            timeout: 2500
          })

          // TODO
          try {
            await this.uploadFiles(this.request.filesGroupsMap.images, false)
          } catch (error) {
            this.$q.notify({
              type: 'negative',
              message: error.message,
              progress: true,
              timeout: 8000
            })

            this.$emit('task-created', creationResult)

            return
          }

          try {
            await this.uploadFiles(this.request.filesGroupsMap.docFiles, false)
          } catch (error) {
            this.$q.notify({
              type: 'negative',
              message: 'Вложения не прикреплены',
              progress: true,
              timeout: 8000
            })

            this.$emit('task-created', creationResult)
            return
          }

          if (!acceptTaskForExecution) {
            this.$emit('task-created', creationResult)
          } else {
            this.assignTaskToExecutorWithBPMove(this.request.requestId, null, () => {
              this.$emit('task-created', creationResult)
            })
          }
        }.bind(this),
        onFailure: (response) => {
          // const reaction = response.reaction || response.data && response.data.reaction || null
          // if (reaction) {
          //   this.$q.loading.hide()

          //   return new Promise((resolve, reject) => {
          //     this.$d_ask({
          //       callback: (data, action) => {
          //         const confirmed = action === 'yes'
          //         resolve({
          //           confirmed: confirmed,
          //           props: confirmed ? data : null
          //         })
          //       },
          //       header: reaction.title,
          //       warning: reaction.warnings || [],
          //       propsConfig: reaction.props,
          //       buttons: [
          //         { key: 'yes', name: 'Подтвердить' },
          //         { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
          //       ]
          //     })
          //   }).then(reactionResult => {
          //     if (!reactionResult.confirmed) {
          //       return Promise.resolve('cancel')
          //     }

          //     // TODO
          //     // if (props && Object.keys(props).length) {
          //     //   bodyFormData.set('props', JSON.stringify(props))
          //     // }

          //     return Promise.resolve('success')
          //   })
          // } else {

          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    saveTaskChanges: async function (assignTaskToExecutor = true) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      if (!(await this.isTaskValid())) {
        this.$q.loading.hide()
        return
      }

      let bpMoveProps = null
      if (assignTaskToExecutor) {
        this.$q.loading.hide()

        const bpMoveInfo = await this.checkBPMove()
        bpMoveProps = bpMoveInfo.props
        if (!bpMoveInfo.confirmed) {
          return
        } else {
          this.$q.loading.show({ spinnerColor: 'blue-11' })
        }
      }

      this.$emit('save-changes-started')

      await this.uploadFiles(this.request.filesGroupsMap.images)
      await this.uploadFiles(this.request.filesGroupsMap.docFiles)

      const tempRequest = convertRequestToServer(this.request, false, this.requestInitial)
      const tempRequestStr = JSON.stringify(tempRequest)
      const bodyFormData = new FormData()
      bodyFormData.set('requestId', this.request.requestId)
      bodyFormData.set('properties', tempRequestStr)

      axiosPost({
        url: '/service/delta/request/edit',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: function (response) {
          this.$q.notify({
            type: 'positive',
            message: 'Заявка сохранена',
            progress: true,
            timeout: 3000
          })

          if (!assignTaskToExecutor) {
            this.$emit('task-updated', response.data.result)
          } else {
            this.assignTaskToExecutorWithBPMove(this.request.requestId, bpMoveProps, (error, result) => {
              if (!error) {
                this.$emit('task-updated', result)
              }
            })
          }
        }.bind(this),
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    selectExecutor () {
      this.$emit('select-executor')
    },
    uploadFiles: async function (filesGroup, notify = true) {
      try {
        return await filesGroup.uploadFiles({
          notify,
          target: this
        })
      } catch (error) {
        throw new Error(error.message)
      }
    },
    changePBState: function (state, props, errMsg) {
      const bodyFormData = new FormData()
      bodyFormData.set('objectId', this.request.bpContextId)

      if (props != null) {
        bodyFormData.set('props', JSON.stringify(props))
      }

      axiosPost({
        url: '/service/delta/requestBusinessProcess/' + state,
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Статус задания изменен',
            progress: true,
            timeout: 3000
          })
          this.$emit('task-updated')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    }
  }
}

